export interface StepContent {
  title: string;
  description: string;
}

export const STEP_CONTENT: StepContent[] = [
  {
    title: 'The Language Model',
    description: 'We start with a neural network that generates text one token at a time.',
  },
  {
    title: 'Training Setup',
    description:
      'To improve the model, we give it a prompt to complete. But there\'s no single right answer.',
  },
  {
    title: 'Sample Responses',
    description:
      'The model generates several different responses from the same prompt, giving us a batch to compare.',
  },
  {
    title: 'Score Responses',
    description:
      'A reward function scores each response based on whatever we\'re optimizing for.',
  },
  {
    title: 'Compare to Average',
    description:
      'Responses scoring above the group average get reinforced; below-average ones get suppressed.',
  },
  {
    title: 'GRPO',
    description:
      'So far, this is identical to GRPO. The difference is how we assign credit to individual tokens.',
  },
  {
    title: 'Token Weighting',
    description:
      'GRPO weights tokens by position, assuming some contribute more to the outcome than others.',
  },
  {
    title: 'GSPO',
    description:
      'GSPO weights all tokens equally. Good response? Reinforce the whole thing.',
  },
  {
    title: 'Better Results',
    description:
      'This simplification reduces gradient variance, leading to more stable training.',
  },
];
